import React from "react";
import "./about.css";
import { Container } from "react-bootstrap";
import AboutCommon from "./AboutCommon";
const About = () => {
  return (
    <>
      <div className="bg">
        <p style={{ height: "70vh" }}></p>
      </div>
      <AboutCommon></AboutCommon>
    </>
  );
};

export default About;
